module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    class: {
      loading: _vm.isLoading
    },
    attrs: {
      "id": "view-category"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', {
    staticClass: "subtitle",
    attrs: {
      "id": "set-anchor"
    }
  }, [_vm._v(_vm._s(_vm.setName))]), _vm._v(" "), (_vm.notification) ? _c('div', {
    staticClass: "notification is-info"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.notification = ''
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.notification) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "50"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "width": "75"
    }
  }, [_vm._v("Qty")]), _vm._v(" "), _c('th', {
    staticClass: "clickable",
    attrs: {
      "width": "75"
    },
    on: {
      "click": function($event) {
        _vm.sortBy('available-quantity')
      }
    }
  }, [_vm._v("Avail")]), _vm._v(" "), _c('th', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.sortBy('product-title')
      }
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.sortBy('condition')
      }
    }
  }, [_vm._v("Cond")]), _vm._v(" "), _c('th', {
    staticClass: "clickable",
    on: {
      "click": function($event) {
        _vm.sortBy('price')
      }
    }
  }, [_vm._v("Price")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedProducts), function(p) {
    return _c('tr', [_c('td', [_c('button', {
      staticClass: "button is-primary",
      attrs: {
        "disabled": p.quantity < 1 || p.quantity > p.available_quantity
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.addToCart(p)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-cart-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (p.quantity),
        expression: "p.quantity",
        modifiers: {
          "number": true
        }
      }],
      staticClass: "input quantity",
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (p.quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(p, "quantity", _vm._n($event.target.value))
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.available_quantity))]), _vm._v(" "), _c('td', [_c('card-title', {
      attrs: {
        "title": p.title,
        "image-url": p.image
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(p.variant.title))]), _vm._v(" "), _c('td', [_vm._v("$" + _vm._s(p.variant.price))])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fe8782e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ViewCategory.vue
// module id = 500
// module chunks = 1